module.exports = __webpack_public_path__ + "static/img/covid-19.b58582b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/covid-19.png
// module id = DhJl
// module chunks = 4